import React, { useEffect, useState } from "react";
import { Switch, Pagination } from "antd";
import { NodeExpandOutlined } from "@ant-design/icons";
import "./index.scss";
import phosphorImg from "./images/phosphor.png";
import { stationApi } from "@api/newApi";
import { connect } from "react-redux";
import TimeSharingControlModal from "../../../components/TimeSharingControlModal";
import Chart from "../components/Chart";

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [aicontrol, setAicontrol] = useState(true);
  const [aicontrol1, setAicontrol1] = useState(false);
  const [show, setShow] = useState(false);
  const [dataInfo, setDataInfo] = useState({});
  const [settingParams, setSettingParams] = useState({});
  const [leftChart, setLeftChart] = useState([]);
  const [rightChart, setRightChart] = useState([]);

  useEffect(() => {
    getData();
    getChartLeftData();
    getChartRightData();
  }, []);

  const getChartLeftData = () => {
    stationApi.getPhosphorusAnalyzeLeftChart().then((res) => {
      if (res.status !== "0") return;
      setLeftChart(res.data);
    });
  };

  const getChartRightData = () => {
    stationApi.getPhosphorusAnalyzeRightChart().then((res) => {
      if (res.status !== "0") return;
      setRightChart(res.data);
    });
  };

  const getData = () => {
    stationApi.findFlowByStationId(stationId).then((res) => {
      if (res.status !== "0") return;
      const { processFlowUnitDTOList = [] } = res.data;
      const diyAttrList = processFlowUnitDTOList.flatMap(
        (item) => item.diyAttrList
      );
      const params = {};
      const params1 = {};
      diyAttrList.forEach((item) => {
        params[item.attrCode] = {
          ...item,
        };
        params1[item.attrCode] = item.value;
      });
      setDataInfo(params);
      setSettingParams(params1);
    });
  };

  const settingValue = () => {};

  const onChange = () => {};

  const showModal = () => {
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
  };

  return (
    <div className="phosphorus">
      <div className="dosing-controlls">
        <div className="dosing-switch">
          <div className="text">AI控制</div>
          <Switch checked={aicontrol} onChange={(e) => setAicontrol(e)} />
        </div>
        <div className="time-sharing-control">
          <div
            className="tsc-text"
            onClick={showModal}
            style={{ borderRadius: 5 }}
          >
            分时控制
            <NodeExpandOutlined />
          </div>
        </div>
      </div>

      <div className="dosing-process">
        <div className="bg">
          <img src={phosphorImg} />
        </div>
        <div
          className="posi-elements-wrap"
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "100%",
            height: "100%",
          }}
        >
          <div className="device-style1" style={{ left: "32.25%", top: "2%" }}>
            智能曝气
          </div>
          <div className="device-style1" style={{ left: "40%", top: "24%" }}>
            鼓风机控制
          </div>
          <div className="device-style5" style={{ left: 0, bottom: "39.5%" }}>
            <div className="device-s5-item">
              <span className="name">进水COD：</span>
              <span className="val">
                {dataInfo["ZXJCS_JS_COD_Y"]
                  ? dataInfo["ZXJCS_JS_COD_Y"].value
                  : ""}
              </span>
              <span className="unit">
                {dataInfo["ZXJCS_JS_COD_Y"]
                  ? dataInfo["ZXJCS_JS_COD_Y"].unit
                  : ""}
              </span>
            </div>
            <div className="device-s5-item">
              <span className="name">进水水温：</span>
              <span className="val">
                {dataInfo["ZXJCS_JS_SW_Y"]
                  ? dataInfo["ZXJCS_JS_SW_Y"].value
                  : ""}
              </span>
              <span className="unit">
                {dataInfo["ZXJCS_JS_SW_Y"]
                  ? dataInfo["ZXJCS_JS_SW_Y"].unit
                  : ""}
              </span>
            </div>
            <div className="device-s5-item">
              <span className="name">进水累计流量：</span>
              <span className="val">
                {dataInfo["ZXJCS_JS_LJLL_Y"]
                  ? dataInfo["ZXJCS_JS_LJLL_Y"].value
                  : ""}
              </span>
              <span className="unit">
                {dataInfo["ZXJCS_JS_LJLL_Y"]
                  ? dataInfo["ZXJCS_JS_LJLL_Y"].unit
                  : ""}
              </span>
            </div>
          </div>
          <div
            className="device-style5"
            style={{ right: "10%", bottom: "39%" }}
          >
            <div className="device-s5-item">
              <span className="name">出水COD：</span>
              <span className="val">
                {dataInfo["ZXJCS_CS_COD_Y"]
                  ? dataInfo["ZXJCS_CS_COD_Y"].value
                  : ""}
              </span>
              <span className="unit">
                {dataInfo["ZXJCS_CS_COD_Y"]
                  ? dataInfo["ZXJCS_CS_COD_Y"].unit
                  : ""}
              </span>
            </div>
            <div className="device-s5-item">
              <span className="name">出水水温：</span>
              <span className="val">
                {dataInfo["ZXJCS_CS_SW_Y"]
                  ? dataInfo["ZXJCS_CS_SW_Y"].value
                  : ""}
              </span>
              <span className="unit">
                {dataInfo["ZXJCS_CS_SW_Y"]
                  ? dataInfo["ZXJCS_CS_SW_Y"].unit
                  : ""}
              </span>
            </div>
            <div className="device-s5-item">
              <span className="name">出水累计流量：</span>
              <span className="val">
                {dataInfo["ZXJCS_CS_LJLL_Y"]
                  ? dataInfo["ZXJCS_CS_LJLL_Y"].value
                  : ""}
              </span>
              <span className="unit">
                {dataInfo["ZXJCS_CS_LJLL_Y"]
                  ? dataInfo["ZXJCS_CS_LJLL_Y"].unit
                  : ""}
              </span>
            </div>
          </div>

          <div>
            <div
              className="custom-html"
              style={{
                right: "27%",
                bottom: "34%",
              }}
            >
              <div className="h">1#氨氮</div>
              <div className="v">
                {dataInfo["SHC1_1_NH3N_Y"]
                  ? dataInfo["SHC1_1_NH3N_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "22.5%",
                bottom: "34%",
              }}
            >
              <div className="h">1#硝酸盐</div>
              <div className="v">
                {dataInfo["SHC1_XSY1_Z_Y"]
                  ? dataInfo["SHC1_XSY1_Z_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "31%",
                bottom: "37%",
              }}
            >
              <div className="h">1#曝气调节阀</div>
              <div className="v">
                {dataInfo["SHC_TJF1_KDFK_Y"]
                  ? dataInfo["SHC_TJF1_KDFK_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "26%",
                bottom: "25%",
              }}
            >
              <div className="h">2#氨氮</div>
              <div className="v">
                {dataInfo["SHC2_2_NH3N_Y"]
                  ? dataInfo["SHC2_2_NH3N_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "21.5%",
                bottom: "25%",
              }}
            >
              <div className="h">2#硝酸盐</div>
              <div className="v">
                {dataInfo["SHC2_XSY2_Z_Y"]
                  ? dataInfo["SHC2_XSY2_Z_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "31%",
                bottom: "27.5%",
              }}
            >
              <div className="h">2#曝气调节阀</div>
              <div className="v">
                {dataInfo["SHC_TJF2_KDFK_Y"]
                  ? dataInfo["SHC_TJF2_KDFK_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "42.5%",
                bottom: "37%",
              }}
            >
              <div className="h">3#曝气调节阀</div>
              <div className="v success">
                {dataInfo["SHC_3TJF_KDFK_Y"]
                  ? dataInfo["SHC_3TJF_KDFK_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "42.5%",
                bottom: "27.5%",
              }}
            >
              <div className="h">4#曝气调节阀</div>
              <div className="v success">
                {dataInfo["SHC_TJF4_KDFK_Y"]
                  ? dataInfo["SHC_TJF4_KDFK_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "47%",
                bottom: "37%",
              }}
            >
              <div className="h">5#曝气调节阀</div>
              <div className="v success">
                {dataInfo["SHC_TJF5_KDFK_Y"]
                  ? dataInfo["SHC_TJF5_KDFK_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "47%",
                bottom: "27.5%",
              }}
            >
              <div className="h">6#曝气调节阀</div>
              <div className="v success">
                {dataInfo["SHC_TJF6_KDFK_Y"]
                  ? dataInfo["SHC_TJF6_KDFK_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "51.5%",
                bottom: "37%",
              }}
            >
              <div className="h">7#曝气调节阀</div>
              <div className="v success">
                {dataInfo["SHC_TJF7_KDFK_Y"]
                  ? dataInfo["SHC_TJF7_KDFK_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "51.5%",
                bottom: "27.5%",
              }}
            >
              <div className="h">8#曝气调节阀</div>
              <div className="v success">
                {dataInfo["SHC_TJF8_KDFK_Y"]
                  ? dataInfo["SHC_TJF8_KDFK_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "56%",
                bottom: "37%",
              }}
            >
              <div className="h">9#曝气调节阀</div>
              <div className="v success">
                {dataInfo["SHC_TJF9_KDFK_Y"]
                  ? dataInfo["SHC_TJF9_KDFK_Y"].value
                  : ""}
              </div>
            </div>
            <div
              className="custom-html"
              style={{
                right: "56%",
                bottom: "27.5%",
              }}
            >
              <div className="h">10#曝气调节阀</div>
              <div className="v success">
                {dataInfo["SHC_TJF10_KDFK_Y"]
                  ? dataInfo["SHC_TJF10_KDFK_Y"].value
                  : ""}
              </div>
            </div>
          </div>

          <div
            className="device-style6"
            style={{ left: "53%", bottom: "46%", fontSize: 12 }}
          >
            1#厌氧区溶解氧：
            {dataInfo["SHC_1YYQRJY_1YYQRJY_Y"]
              ? dataInfo["SHC_1YYQRJY_1YYQRJY_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "53%", bottom: "44%", fontSize: 12 }}
          >
            1#缺氧区溶解氧：
            {dataInfo["SHC_1QYQRJY_1QYQRJY_Y"]
              ? dataInfo["SHC_1QYQRJY_1QYQRJY_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "53%", bottom: "42%", fontSize: 12 }}
          >
            1#后缺氧区溶解氧：
            {dataInfo["SHC_1HQYQRJY_1HQYQRJY_Y"]
              ? dataInfo["SHC_1HQYQRJY_1HQYQRJY_Y"].value
              : ""}
          </div>

          <div
            className="device-style6"
            style={{ left: "43%", bottom: "46%", fontSize: 12 }}
          >
            1#厌氧区ORP：
            {dataInfo["SHC2_YYQ1_ORP_Y"]
              ? dataInfo["SHC2_YYQ1_ORP_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "43%", bottom: "44%", fontSize: 12 }}
          >
            1#好氧区好氧段DO：
            {dataInfo["SHC1_HYQHYD1_DO_Y"]
              ? dataInfo["SHC1_HYQHYD1_DO_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "43%", bottom: "42%", fontSize: 12 }}
          >
            1#好氧区消氧段DO：
            {dataInfo["SHC1_HYQXYD1_DO_Y"]
              ? dataInfo["SHC1_HYQXYD1_DO_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "43%", bottom: "40%", fontSize: 12 }}
          >
            1#后好氧区消氧段DO：
            {dataInfo["SHC1_HYQHHYQ1_DO_Y"]
              ? dataInfo["SHC1_HYQHHYQ1_DO_Y"].value
              : ""}
          </div>

          <div
            className="device-style6"
            style={{ left: "53%", bottom: "24%", fontSize: 12 }}
          >
            2#厌氧区溶解氧：
            {dataInfo["SHC_2YYQRJY_2YYQRJY_Y"]
              ? dataInfo["SHC_2YYQRJY_2YYQRJY_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "53%", bottom: "22%", fontSize: 12 }}
          >
            2#缺氧区溶解氧：
            {dataInfo["SHC_2QYQRJY_2QYQRJY_Y"]
              ? dataInfo["SHC_2QYQRJY_2QYQRJY_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "53%", bottom: "20%", fontSize: 12 }}
          >
            2#后缺氧区溶解氧：
            {dataInfo["SHC_2HQYQRJY_2HQYQRJY_Y"]
              ? dataInfo["SHC_2HQYQRJY_2HQYQRJY_Y"].value
              : ""}
          </div>

          <div
            className="device-style6"
            style={{ left: "43%", bottom: "24%", fontSize: 12 }}
          >
            2#厌氧区ORP：
            {dataInfo["SHC2_YYQ2_ORP_Y"]
              ? dataInfo["SHC2_YYQ2_ORP_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "43%", bottom: "22%", fontSize: 12 }}
          >
            2#好氧区好氧段DO：
            {dataInfo["SHC2_HYQHYD2_DO_Y"]
              ? dataInfo["SHC2_HYQHYD2_DO_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "43%", bottom: "20%", fontSize: 12 }}
          >
            2#好氧区消氧段DO：
            {dataInfo["SHC2_HYQXYD2_DO_Y"]
              ? dataInfo["SHC2_HYQXYD2_DO_Y"].value
              : ""}
          </div>
          <div
            className="device-style6"
            style={{ left: "43%", bottom: "18%", fontSize: 12 }}
          >
            2#后好氧区消氧段DO：
            {dataInfo["SHC2_HYQHHYQ2_DO_Y"]
              ? dataInfo["SHC2_HYQHHYQ2_DO_Y"].value
              : ""}
          </div>
          <div
            className="custom-html"
            style={{
              left: "30%",
              top: "12%",
              height: 50,
            }}
          >
            <div className="h">1#鼓风机运行状态</div>
            <div
              className={
                dataInfo["GFJF_1FJZT_1_YX_T"] &&
                dataInfo["GFJF_1FJZT_1_YX_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["GFJF_1FJZT_1_YX_T"] &&
              dataInfo["GFJF_1FJZT_1_YX_T"].value == 1
                ? "启动"
                : "停止"}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              left: "30%",
              top: "21%",
              height: 50,
            }}
          >
            <div className="h">2#鼓风机运行状态</div>
            <div
              className={
                dataInfo["GFJF_2FJZT_1_YX_T"] &&
                dataInfo["GFJF_2FJZT_1_YX_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["GFJF_2FJZT_1_YX_T"] &&
              dataInfo["GFJF_2FJZT_1_YX_T"].value == 1
                ? "启动"
                : "停止"}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              left: "30%",
              top: "30%",
              height: 50,
            }}
          >
            <div className="h">3#鼓风机运行状态</div>
            <div
              className={
                dataInfo["GFJF_3FJZT_1_YX_T"] &&
                dataInfo["GFJF_3FJZT_1_YX_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["GFJF_3FJZT_1_YX_T"] &&
              dataInfo["GFJF_3FJZT_1_YX_T"].value == 1
                ? "启动"
                : "停止"}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              left: "30%",
              top: "40%",
              height: 50,
            }}
          >
            <div className="h">4#鼓风机运行状态</div>
            <div
              className={
                dataInfo["GFJF_4FJZT_1_YX_T"] &&
                dataInfo["GFJF_4FJZT_1_YX_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["GFJF_4FJZT_1_YX_T"] &&
              dataInfo["GFJF_4FJZT_1_YX_T"].value == 1
                ? "启动"
                : "停止"}
            </div>
          </div>

          <div className="setting-params">
            <div className="setting-item">
              <div className="setting-item-title">1#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  placeholder="请输入1#曝气调节阀"
                  value={settingParams["SHC_TJF1_KDFK_Y"]}
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_TJF1_KDFK_Y: e.target.value,
                    })
                  }
                  onBlur={settingValue}
                />
              </div>
            </div>
            <div className="setting-item">
              <div className="setting-item-title">2#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  value={settingParams["SHC_TJF2_KDFK_Y"]}
                  placeholder="请输入2#曝气调节阀开度"
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_TJF2_KDFK_Y: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="setting-item">
              <div className="setting-item-title">3#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  value={settingParams["SHC_3TJF_KDFK_Y"]}
                  placeholder="请输入3#曝气调节阀开度"
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_3TJF_KDFK_Y: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="setting-item">
              <div className="setting-item-title">4#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  value={settingParams["SHC_TJF4_KDFK_Y"]}
                  placeholder="请输入4#曝气调节阀开度"
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_TJF4_KDFK_Y: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="setting-item">
              <div className="setting-item-title">5#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  value={settingParams["SHC_TJF5_KDFK_Y"]}
                  placeholder="请输入5#曝气调节阀开度"
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_TJF5_KDFK_Y: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="setting-item">
              <div className="setting-item-title">6#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  value={settingParams["SHC_TJF6_KDFK_Y"]}
                  placeholder="请输入5#曝气调节阀开度"
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_TJF6_KDFK_Y: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="setting-item">
              <div className="setting-item-title">7#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  value={settingParams["SHC_TJF7_KDFK_Y"]}
                  placeholder="请输入5#曝气调节阀开度"
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_TJF7_KDFK_Y: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="setting-item">
              <div className="setting-item-title">8#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  value={settingParams["SHC_TJF8_KDFK_Y"]}
                  placeholder="请输入8#曝气调节阀开度"
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_TJF8_KDFK_Y: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="setting-item">
              <div className="setting-item-title">9#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  value={settingParams["SHC_TJF9_KDFK_Y"]}
                  placeholder="请输入9#曝气调节阀开度"
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_TJF9_KDFK_Y: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="setting-item">
              <div className="setting-item-title">10#曝气调节阀开度设定:</div>
              <div className="setting-item-input">
                <input
                  type="number"
                  value={settingParams["SHC_TJF10_KDFK_Y"]}
                  placeholder="请输入10#曝气调节阀开度"
                  onChange={(e) =>
                    setSettingParams({
                      ...settingParams,
                      SHC_TJF10_KDFK_Y: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dosing-chart-ai">
        <div
          className="dosing-chart"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Chart
            chartTitle="智能曝气"
            chartData={leftChart}
            id="phosphorusLeftChart"
            width="48%"
            height="100%"
          />
          <Chart
            chartTitle="智能曝气"
            chartData={rightChart}
            id="phosphorusRightChart"
            width="48%"
            height="100%"
          />
        </div>
        <div className="dosing-ai">
          <div className="dosing-switch">
            <div className="text">AI窗口会话</div>
            <Switch checked={aicontrol1} onChange={(e) => setAicontrol1(e)} />
          </div>
          <div className="dosing-ai-list">
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dosing-report">
        <div className="dosing-report-title">智能除磷分析报告</div>
        <div className="dosing-report-content">
          <div className="dosing-report-head">
            <div>生成时间</div>
            <div>报告名称</div>
            <div>报告摘要</div>
            <div>操作</div>
          </div>
          <div className="dosing-report-body">
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
          </div>

          <div className="dosing-report-pages">
            <Pagination
              showQuickJumper
              defaultCurrent={1}
              total={100}
              onChange={onChange}
              showTotal={(total) => `总共${total}条`}
            />
          </div>
        </div>
      </div>
      {show && (
        <TimeSharingControlModal
          visible={show}
          controllType={2}
          onCancel={closeModal}
        />
      )}
    </div>
  );
});
